<div class="card">
    <div class="card__container">
        <section class="card__grid-item">
            <mat-card class="card__mat">
                <ng-content></ng-content>
            </mat-card>
        </section>
        <section class="card__grid-item card__grid-item--right">
            <span class="card__title">
                Proactive <br>
                Fraud Management <br>
                Solutions
            </span>
            <span class="card__subtitle">
                Data Analysis
                <span class="card__dot"></span>
                Collaboration
                <span class="card__dot"></span>
                Interception
            </span>
        </section>
    </div>    
</div>